// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__TixrB","logo":"styles_logo__SkFMu","title":"styles_title__Kvp0E"};